module.exports = __webpack_public_path__ + "img/02.e460cdb8.png";